import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const FreelancerCard = ({ freelancer, index = 0 }) => {
  const { lang, t } = useLanguage();
  const role = lang === "en" ? freelancer.role_en : freelancer.role_pt;
  const desc = lang === "en" ? freelancer.short_en : freelancer.short_pt;

  return (
    <Link

      to={`/freelancers/${freelancer.slug}`}

      className="group block"

    >
    <article
      className="group bg-white border border-[rgba(117,148,122,0.15)] rounded-2xl p-6 shadow-[0_4px_24px_rgba(32,44,33,0.04)] hover:-translate-y-1 hover:shadow-[0_12px_48px_rgba(32,44,33,0.08)] transition-all duration-300 flex flex-col"
      data-testid={`freelancer-card-${freelancer.slug}`}
      style={{ animationDelay: `${index * 75}ms` }}
    >
      <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-[#E6EDE7]">
        <img
          src={freelancer.avatar}
          alt={freelancer.name}
          className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="mt-6 flex-1 flex flex-col">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-heading text-xl font-semibold tracking-tight text-[#202C21]">
              {freelancer.name}
            </h3>
            <p className="text-sm text-[#5F7C63] font-medium mt-0.5">{role}</p>
          </div>
          <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#8A9A8B] mt-1 whitespace-nowrap">
            Ericeira
          </span>
        </div>
        <p className="mt-4 text-[#5C6B5D] text-sm leading-relaxed flex-1">
          {desc}
        </p>
        <Link
          to={`/freelancers/${freelancer.slug}`}
          className="mt-6 inline-flex items-center justify-between gap-2 bg-[#F3F4F1] hover:bg-[#DDE5DD] text-[#202C21] rounded-full px-5 py-3 text-sm font-medium transition-colors"
          data-testid={`view-profile-${freelancer.slug}`}
        >
          <span>{t.freelancers.view_profile}</span>
          <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
        </Link>
      </div>
    </article>
    </Link>
  );
};

export default FreelancerCard;
